import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <div>
  <App />
  <ToastContainer />
  </div>
   
    
  
);
